import { GetTokenForHeader, GetUserIdForHeader } from './CommonHelper';

const ADMIN_ORIGIN = 'https://admin.uklbutter.com';
const READ_PATHS = new Set([
    '/api/v1/common/order-payment-qr',
    '/api/v1/common/order-confirmation',
    '/api/v1/dynamic/dataoperation/get-customer-order-history-master',
    '/api/v1/common/get-customer-cart-items/cart-data',
    '/api/v1/common/get-coupon-code-discount-value/calculate-coupon-discount',
    '/api/v1/common/localization-cstm-portal/get-localization-data',
]);

// This transport is scoped to confirmation; it never follows redirects or sends writes.
export const readOrderConfirmationApi = async (endpoint, subpath, body, ignoredHeaders, method = 'POST') => {
    const path = '/' + (subpath || '') + endpoint;
    if (method !== 'POST' || !READ_PATHS.has(path)) return { status: 0, data: null };
    try {
        const token = await GetTokenForHeader();
        const userId = await GetUserIdForHeader();
        if (!userId) return { status: 401, data: null };
        const url = ADMIN_ORIGIN + path;
        const response = await fetch(url, {
            method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error', cache: 'no-store',
            referrerPolicy: 'no-referrer',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Token: token || '', UserID: String(userId) },
            body: JSON.stringify(body),
        });
        if (response.redirected || response.url !== url) return { status: 0, data: null };
        if (!response.ok) return { status: response.status, data: null };
        const contentType = (response.headers.get('content-type') || '').split(';')[0].trim().toLowerCase();
        const legacyJson = contentType === 'json' && !['/api/v1/common/order-payment-qr', '/api/v1/common/order-confirmation'].includes(path);
        if (contentType !== 'application/json' && !legacyJson) return { status: 0, data: null };
        return { status: response.status, data: await response.json() };
    } catch {
        return { status: 0, data: null };
    }
};

// The server selects the customer's latest saved order when no order number is supplied.
export const loadOrderQrPayment = async (orderNumber) => {
    if (orderNumber != null && (typeof orderNumber !== 'string' || !orderNumber.trim() || orderNumber.length > 500)) {
        return { status: 404, data: null };
    }
    const response = await readOrderConfirmationApi('order-confirmation', 'api/v1/common/',
        orderNumber ? { orderNumber } : {});
    const savedOrderNumber = response.data?.orderNumber ?? response.data?.OrderNumber;
    return { ...response, requestedOrderNumber: orderNumber || savedOrderNumber };
};
